'use client';

import { useTranslations } from 'next-intl';
import './transcript-analysing-content-progress.css';

export function TranscriptAnalysingContentProgress() {
  const t = useTranslations('features');

  return (
    <div className="flex flex-col justify-center items-center">
      <div className="w-[64px] h-[64px]">
        {/* not good quality for windows https://d3hogio4d1txum.cloudfront.net/transcript-progress-animation.20032024112500.mp4 */}
        <video
          src="/assets/img/transcript-progress-animation-video.mp4"
          width={64}
          height={64}
          autoPlay={true}
          loop={true}
        ></video>
      </div>
      <div className="relative w-[108px] h-[4px] mt-[16px] mb-[24px] bg-[#eeeeee] overflow-hidden">
        <div className="absolute top-0 left-0 h-[4px] w-[23px] bg-[#00bcd4] transcript-animate-progress"></div>
      </div>
      <div className="text-[13px] text-black">{t('transcript.analyzing_content')}</div>
    </div>
  );
}
